import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { logAppConfig } from './config/appConfig'
import './i18n/i18n'

// Mostrar configuración al cargar la aplicación
logAppConfig();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
